<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/active/list" color="blue">上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">檢視/修改活動資訊</p>

          <v-text-field
            v-model="tempData.active_name"
            :rules="[formRules.required]"
            :persistent-hint="true"
            label="活動名稱"
            outlined
          ></v-text-field>

          <v-text-field
              type="text"
              v-model.active_code="tempData.active_code"
              label="活動代碼"
              disabled
              outlined
            ></v-text-field>

          <v-select
            v-model="tempData.points"
            :items="itemsPoints"
            placeholder="序號金額"
            outlined>
          </v-select>

          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="tempData.start_time"
                label="開始時間"
                :rules="[formRules.required]"
                readonly
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="tempData.start_time" locale="zh-cn" color="blue"></v-date-picker>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="tempData.end_time"
                label="結束時間"
                :rules="[formRules.required]"
                readonly
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="tempData.end_time" locale="zh-cn" color="blue"></v-date-picker>
          </v-menu>

        </v-card-text>
      </v-card>

      <v-card-text>

        <v-select
          v-model="filterSerialNumber"
          :items="machineTypeList"
          item-text="text"
          item-value="value"
          solo
        ></v-select>

        <v-simple-table class="mb-6">

          <tbody>
            <tr>
                <td colspan="3">
                     <a  color="teal" label="" @click="checkAll()">選擇全部</a>
                     &nbsp;&nbsp;&nbsp;&nbsp;
                     <a  color="teal" label="" @click="cancelAll()">取消全部</a>
                </td>
            </tr>
            <tr
              v-for="item in machine_list"
              @click="checkbox(item)"
              :style="{ cursor: $hasHigherPermission ? 'default' : 'pointer' }"
              v-if="showMachine(item)"
            >
              <td>
                <v-checkbox v-model="item.allow_use" color="teal" @click.prevent></v-checkbox>
              </td>
              <td>{{ item.serial_number }}</td>
              <td>{{ item.name }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!valid" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更活動資訊？" text />
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import activesApi from "@/api/actives";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      id: 0,

      activeInfo: {},
      tempData: {},
      filterSerialNumber: '',
      machine_list: [],
      itemsPoints: [30,90,100,160,240,300],

      dialog: false,

      valid: false
    };
  },

  computed: {
    $hasHigherPermission() {
        //return true;
        return [0, 300, 400].indexOf(this.roleId) === -1;
    }
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.activeInfo = JSON.parse(JSON.stringify(res.data));
      this.tempData = JSON.parse(JSON.stringify(res.data));
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    checkbox(item) {

      // if (this.$hasHigherPermission) {
      //   return;
      // }

      item.allow_use = !item.allow_use;
    },

    checkAll(){
      this.machine_list.forEach(machine => {
        machine.allow_use=true;
      });
    },

    cancelAll(){
      this.machine_list.forEach(machine => {
        machine.allow_use=false;
      });
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.activeInfo));
    },

    showMachine(item){
        if(this.filterSerialNumber == ''){
            return true;
        }
        else if(item.serial_number.substring(0,3) == this.filterSerialNumber){
            return true;
        }
        else {
            return false;
        }
    },

    submit() {

      const allow_machine_ids = [];
      const disable_machine_ids = [];
      this.machine_list.forEach(machine => {
        if (machine.allow_use && this.showMachine(machine) == true) {
            allow_machine_ids.push(machine.machine_id);
        }
        else{
            disable_machine_ids.push(machine.machine_id);
        }
      });


      if (!allow_machine_ids.length) {
        allow_machine_ids.push(0);
      }
      if (!disable_machine_ids.length) {
        disable_machine_ids.push(0);
      }

      let postData = {
          active_name: this.tempData.active_name,
          points: this.tempData.points,
          start_time: this.tempData.start_time,
          end_time: this.tempData.end_time,
          available: this.tempData.available,
          allow_machine_ids: allow_machine_ids,
          disable_machine_ids: disable_machine_ids,
        };
        //console.log(postData);return ;


      activesApi
        .updateByID(this.id, postData)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
            this.reset();
          } else {
            window.location.reload();
            //this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.id = Number(this.$route.params.id);

    activesApi
      .getByID(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});

    activesApi
      .getActiveToMachine(this.id)
      .then(res => {
        this.machine_list = res.data
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
